// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueAnimateNumber from 'vue-animate-number'
import animated from 'animate.css'

import './assets/css/common.css'
import 'swiper/dist/css/swiper.css'
Vue.prototype.$show = true
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper);
Vue.use(VueAnimateNumber);
Vue.use(animated)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js